(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hairhd-hero-video"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-hm-hero-motion]').forEach(root => {
    const video = root.querySelector('[data-hm-hero-video]');
    const still = root.querySelector('[data-hm-hero-still]');
    if (!video) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let pausedByUser = false;
    let inView = false;
    const label = () => {
      const action = video.paused ? root.dataset.playLabel : root.dataset.pauseLabel;
      root.setAttribute('aria-label', root.dataset.motionAlt + ' · ' + action);
      root.setAttribute('aria-pressed', String(!video.paused));
    };
    const play = () => {
      if (!video.src) video.src = video.dataset.videoUrl;
      video.muted = true;
      return video.play().catch(() => { label(); });
    };
    const auto = () => {
      if (inView && !pausedByUser && !reduced.matches && !document.hidden) play();
      else if (!video.paused) video.pause();
    };
    video.addEventListener('playing', () => { video.dataset.ready = 'true'; label(); });
    video.addEventListener('pause', label);
    video.addEventListener('error', () => { delete video.dataset.ready; root.removeAttribute('role'); root.removeAttribute('tabindex'); });
    const toggle = () => {
      if (video.paused) { pausedByUser = false; play(); }
      else { pausedByUser = true; video.pause(); }
    };
    root.addEventListener('click', toggle);
    root.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
    });
    label();
    inView = root.getBoundingClientRect().top < (window.innerHeight || 0);
    auto();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => { inView = entries[0].isIntersecting; auto(); }, { rootMargin: '200px 0px' }).observe(root);
    }
    reduced.addEventListener('change', auto);
    document.addEventListener('visibilitychange', auto);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hairhd-model-visual"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-hm-gallery]').forEach(root => {
    const stage = root.querySelector('[data-hm-stage]');
    if (!stage) return;
    const photos = [...root.querySelectorAll('[data-hm-photo]')];
    const markers = [...root.querySelectorAll('[data-hm-dot], [data-hm-thumb]')];
    const dialog = root.querySelector('[data-hm-gallery-dialog]');
    const sale = root.closest('.hm-sale');
    const markerId = marker => marker.dataset.hmDot || marker.dataset.hmThumb;
    let eligible = photos;
    let index = 0;
    let focusReturn = null;
    let settled = false;
    let warmCurrent = () => {};
    const mark = () => {
      const current = eligible[index];
      markers.forEach(marker => {
        marker.hidden = !eligible.some(photo => photo.dataset.hmPhoto === markerId(marker));
        marker.setAttribute('aria-pressed', String(Boolean(current) && current.dataset.hmPhoto === markerId(marker)));
      });
      if (settled) warmCurrent();
    };
    const show = (position, smooth = true) => {
      if (!eligible.length) return;
      index = (position + eligible.length) % eligible.length;
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (stage.scrollTo) stage.scrollTo({ left: eligible[index].offsetLeft - eligible[0].offsetLeft, behavior: smooth && !reduced ? 'smooth' : 'auto' });
      mark();
    };
    let currentId = null;
    const update = id => {
      if (id === currentId) return;
      currentId = id;
      eligible = photos.filter(photo => !photo.dataset.hmPhotoVariants || photo.dataset.hmPhotoVariants.split(',').includes(id));
      photos.forEach(photo => { photo.hidden = !eligible.includes(photo); });
      const featured = eligible.findIndex(photo => photo.dataset.hmPhotoVariants === id);
      show(featured < 0 ? 0 : featured, false);
    };
    const restore = () => update(sale?.querySelector('input[name="variant"]:checked')?.value || '');
    markers.forEach(marker => marker.addEventListener('click', () => {
      const position = eligible.findIndex(photo => photo.dataset.hmPhoto === markerId(marker));
      if (position >= 0) show(position);
    }));
    let ticking = false;
    stage.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        const step = eligible[1] ? eligible[1].offsetLeft - eligible[0].offsetLeft : stage.clientWidth || 1;
        const next = Math.round(stage.scrollLeft / step);
        if (next !== index && eligible[next]) { index = next; mark(); }
      });
    }, { passive: true });
    stage.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
    });
    const zoomImage = dialog?.querySelector('[data-hm-zoom-image]');
    const saving = Boolean(window.navigator?.connection?.saveData);
    const warmed = new Set();
    let zoomToken = 0;
    // Fetch an enlarged photo ahead of the click, once per address.
    const warm = url => {
      if (!url || saving || warmed.has(url) || !window.Image) return;
      warmed.add(url);
      const probe = new window.Image();
      probe.decoding = 'async';
      probe.src = url;
    };
    warmCurrent = () => warm(eligible[index]?.querySelector?.('[data-hm-zoom]')?.href);
    // Once the page has loaded, the other photos load too, so thumbnails and swipes never land on an empty frame.
    const settle = () => {
      if (saving) return;
      settled = true;
      photos.forEach(photo => {
        const img = photo.querySelector?.('img');
        if (img && !photo.hidden && img.loading === 'lazy') img.loading = 'eager';
      });
      warmCurrent();
    };
    root.querySelectorAll('[data-hm-zoom]').forEach(link => {
      ['pointerenter', 'touchstart', 'focus'].forEach(type => link.addEventListener(type, () => warm(link.href), { passive: true }));
      link.addEventListener('click', event => {
        if (!dialog?.showModal || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const source = link.querySelector('img');
        const shown = source.currentSrc || source.src || '';
        const full = link.href;
        const token = ++zoomToken;
        // The photo already on screen opens at once; the largest version replaces it when ready.
        zoomImage.alt = source.alt;
        zoomImage.setAttribute('width', source.getAttribute('width'));
        zoomImage.setAttribute('height', source.getAttribute('height'));
        zoomImage.src = source.complete && shown ? shown : full;
        focusReturn = link;
        dialog.showModal();
        if (zoomImage.src === full || !window.Image) return;
        const next = new window.Image();
        next.src = full;
        const ready = next.decode ? next.decode() : new Promise((resolve, reject) => { next.onload = resolve; next.onerror = reject; });
        ready.then(() => { if (token === zoomToken && dialog.open) zoomImage.src = full; }).catch(() => {});
      });
    });
    root.querySelector('[data-hm-gallery-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog?.addEventListener('close', () => { zoomToken += 1; focusReturn?.focus(); });
    sale?.addEventListener('hairhd:variant', event => update(event.detail.id));
    window.addEventListener('pageshow', restore);
    restore();
    if (document.readyState === 'complete') settle(); else window.addEventListener('load', settle, { once: true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hairhd-story"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-hm-checks]').forEach(list => {
    const reveal = () => { list.dataset.revealed = 'true'; };
    if (!('IntersectionObserver' in window)) { reveal(); return; }
    list.dataset.revealed = 'false';
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { reveal(); observer.disconnect(); }
    }, { threshold: 0.2 });
    observer.observe(list);
    window.setTimeout(() => { if (list.getBoundingClientRect().top < (window.innerHeight || 0)) reveal(); }, 1200);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hairhd-texture-selector"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-hm-texture-selector]').forEach(root => {
    const select = root.querySelector('[data-hm-texture]');
    const sale = root.closest('.hm-sale');
    const straight = sale.querySelector('[data-hm-straight-order]');
    const media = sale.querySelector('[data-hm-model]');
    const pending = root.querySelector('[data-hm-texture-pending]');
    const name = root.querySelector('[data-hm-texture-name]');
    const mediaPending = document.createElement('div');
    mediaPending.className = 'hm-catalogue-media-pending';
    mediaPending.hidden = true;
    media.after(mediaPending);
    const details = sale.nextElementSibling?.querySelector('details');
    const update = () => {
      const preparing = select.value !== 'straight';
      straight.hidden = preparing;
      media.hidden = preparing;
      pending.hidden = !preparing;
      mediaPending.hidden = !preparing;
      if (details) details.hidden = preparing;
      const label = select.selectedOptions[0].textContent;
      name.textContent = label;
      mediaPending.textContent = label + ' — ' + pending.querySelector('p').textContent;
      const url = new URL(window.location.href);
      document.querySelectorAll('[data-hm-return]').forEach(input => { input.value = url.pathname + url.search; });
    };
    const restore = () => {
      const texture = new URL(window.location.href).searchParams.get('texture');
      select.value = [...select.options].some(option => option.value === texture) ? texture : 'straight';
      update();
    };
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      if (select.value === 'straight') url.searchParams.delete('texture');
      else url.searchParams.set('texture', select.value);
      history.replaceState(null, '', url);
      update();
    });
    window.addEventListener('pageshow', restore);
    window.addEventListener('popstate', restore);
    restore();
  });
  } catch(e) { console.error(e); }
})();

})();
